export default __webpack_public_path__ + "static/media/flag-swaziland.3c4cb96d.svg";